import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { imgSrc } from "@/lib/api";

const GRID = { 1: "grid-cols-1", 2: "grid-cols-2", 3: "grid-cols-2", 4: "grid-cols-2" };

export const PostPhotos = ({ postId, images }) => {
  const [open, setOpen] = useState(null);
  if (!images?.length) return null;
  return (
    <>
      <div className={`grid ${GRID[images.length]} gap-2 mt-4 max-w-xl`} data-testid={`post-photos-${postId}`}>
        {images.map((url, i) => (
          <button key={`${url}-${i}`} onClick={() => setOpen(url)} data-testid={`post-photo-${postId}-${i}`}
            className={`overflow-hidden rounded-xl bg-[#F5F5F0] ${images.length === 3 && i === 0 ? "row-span-2" : ""}`}>
            <img src={imgSrc(url)} alt="" loading="lazy"
              className={`w-full h-full object-cover hover:scale-[1.03] transition-transform duration-500 ${images.length === 1 ? "max-h-[420px]" : "aspect-[4/3]"}`} />
          </button>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="bg-white max-w-3xl p-2" data-testid="post-photo-lightbox">
          <DialogTitle className="sr-only">Photo</DialogTitle>
          {open && <img src={imgSrc(open)} alt="" className="w-full max-h-[80vh] object-contain rounded-lg" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
